import React from "react";
import Index from "../Components/Index";

const Home = (props) => {
  return (
    <div className="flex flex-col">
      <Index/>

    </div>
  );
};

export default Home;
